import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/RequisitionAuditReport/Filter'

export default createListViewComponent({
  entityName: entityNames.requisitionAuditReport,
  filterTemplateType: 'RequisitionAuditReport',
  initialFilterDto: (self) => ({
    dateRange: { dateRangeType: 'MonthToDate' },
    auditReportType: 'Requisition',
  }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
  getSettingsType: (self) => 'requisitions',
})(Filter)
